var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reaction-panel"},_vm._l((_vm.reactions),function([key, value]){return _c('ReactionBtn',{key:key,attrs:{"id":_vm.id,"name":key,"count":value,"isSelfReaction":_vm.selfReaction === key}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }